import sendReq from '@/utils/request'

export const listSignal = async ({ commit }, data) => {
    commit('signalLoading', true);
    let res;
    res = await sendReq("get","signals", {params:data})
    commit('listSignal', res.data);
    commit('signalLoading', false);
}

export const signalDetail = async ({ commit }, data) => {
    commit('signalLoading', true);
    let res;
    res = await sendReq("get","signals/"+data.acnt_id)
    commit('signalDetail', res.data);
    commit('signalLoading', false);
}

export const postponeSignals = async ({ commit }, data) => {
    commit('signalLoading', true);
    let res;
    res = await sendReq("get","postpone-signals")
    commit('postponeSignals', res.data);
    commit('signalLoading', false);
}
export const removePostpone = async ({ commit }, data) => {
    commit('signalLoading', true);
    let res;
    res = await sendReq("delete","postpone-signals/"+data.postpone_id)
    commit('signalLoading', false);
}


// WEBPACK FOOTER //
// ./src/store/modules/Alarmsis/Signal/Actions.js